// src/js/main.js
(function ($) {
	function getYouTubeId(url) {
		try {
			const u = new URL(url);
			if (u.hostname.includes('youtu.be')) return u.pathname.slice(1);
			if (u.searchParams.get('v')) return u.searchParams.get('v');
			const m = u.pathname.match(/\/(embed|shorts)\/([A-Za-z0-9_-]{6,})/);
			if (m) return m[2];
		} catch (e) {}
		return null;
	}

	function getVimeoId(url) {
		try {
			const u = new URL(url);
			if (!u.hostname.includes('vimeo.com')) return null;
			const m = u.pathname.match(/\/(\d+)/);
			return m ? m[1] : null;
		} catch (e) {}
		return null;
	}

	function toEmbedUrl(rawUrl) {
		if (!rawUrl) return null;
		const ytId = getYouTubeId(rawUrl);
		if (ytId) {
			return `https://www.youtube-nocookie.com/embed/${ytId}?autoplay=1&rel=0&playsinline=1`;
		}
		const viId = getVimeoId(rawUrl);
		if (viId) {
			return `https://player.vimeo.com/video/${viId}?autoplay=1&title=0&byline=0&portrait=0`;
		}
		return rawUrl;
	}

	function initIndyBlockVideo() {
		$(document).on('click', '.indy-block-video .play-button button', function (e) {
			e.preventDefault();
			e.stopPropagation();

			const $wrapper = $(this).closest('.indy-block-video');
			const $video = $wrapper.find('.video').first();
			if (!$video.length) return;

			if ($video.data('playing') === 1) return;

			const rawUrl = $video.data('src');
			const embedUrl = toEmbedUrl(rawUrl);
			if (!embedUrl) {
				console.warn('indy-block-video: keine gültige data-src gefunden.');
				return;
			}

			const $iframe = $('<iframe>', {
				src: embedUrl,
				title: 'Video player',
				allow:
					'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
				allowfullscreen: 'true',
				loading: 'eager',
			})
				.css({ width: '100%', height: '100%', border: 0 })
				.attr('referrerpolicy', 'strict-origin-when-cross-origin');

			const aspect = $video.data('aspect') || '56.25';
			const $ratio = $('<div>', { class: 'ratio' })
				.css('--bs-aspect-ratio', aspect + '%')
				.append($iframe);

			$video.find('img.thumbnail').remove();
			$video.find('.play-button').remove();
			$video.removeAttr('data-fancybox');
			$video.append($ratio);
			$video.data('playing', 1);
		});
	}

	$(initIndyBlockVideo);
})(jQuery);
